import defaultMenu from "@/system/config/_menu";

const state = {
	menu: [],
	custom: null,
	// RESPONSIVE
	isMobileView: false,
	isTabletView: false,
	// APPEAR
	isMobileMenuOpen: false,
	isMenuCollapsed: false,
	isMenuShadow: true,
	isMenuUnfixed: false,
	menuLayoutType: "left", // left, top, nomenu
	menuType: "blue", // default, flyout, compact
	menuColor: "dark", // dark, blue, gray, white
	flyoutMenuColor: "dark", // dark, blue, gray, white
	systemLayoutColor: "gray", // white, dark, blue, gray, image
	isTopbarFixed: false,
	isContentNoMaxWidth: true,
	isGrayBackground: true,
	isCardShadow: true,
	isSquaredBorders: false,
	isBorderless: false,
	routerAnimation: "slide-fadein-up", // none, slide-fadein-up, slide-fadein-right, fadein, zoom-fadein
	isChatEnabled: false,
	dark: false,
	// SYSTEM
	debug: false,
	env: process.env.VUE_APP_ENVIRONMENT,
};

const getters = {
	settings: (state) => state,
};

const mutations = {
	CHANGE_SETTING(state, payload) {
		state[payload.setting] = payload.value;
	},
	// SET MENU
	SET_MENU(st, menu) {
		st.menu = menu;
	},
	// SET CUSTOM SETTINGS
	SET_CUSTOM_SETTINGS(st, data) {
		st.custom = data;
	},
};

const actions = {
	"SETTINGS/MENU": function ({ commit }, value) {
		let mergeMenu = defaultMenu;

		if (value !== undefined) mergeMenu = value.concat(defaultMenu);
		commit("SET_MENU", mergeMenu);
	},

	"SETTINGS/CUSTOM": function ({ commit }, value) {
		let customConfig = null;
		if (value !== undefined) customConfig = value;
		commit("SET_CUSTOM_SETTINGS", customConfig);
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
